import React, { useRef } from "../../__compat__/react/main.entry.mjs.mjs";
import { useOutsideClick } from "../../api/hooks/useOutsideClick.mjs.mjs";
import { StyledPopoverLite, StyledPopoverLiteContainer, StyledTriggerContainer, } from "./PopoverLite.styles.mjs.mjs";
import { useFocusTrap } from "./utils/use-focus-trap.mjs.mjs";
import { useEscapeKey } from "./utils/use-esc-key-listener.mjs.mjs";
import { usePopoverLitePosition, } from "./utils/use-popover-lite-position.mjs.mjs";
export const PopoverLite = ({ triggerElement, content, open, onClose, id, withTip, alignment, }) => {
    const popoverLiteId = id;
    const bubbleRef = useRef(null);
    const containerRef = useRef(null);
    const triggerRef = useRef(null);
    useOutsideClick([containerRef], onClose);
    useFocusTrap({
        open,
        ref: bubbleRef,
        triggerRef,
    });
    useEscapeKey(onClose);
    usePopoverLitePosition({ ref: bubbleRef, open, alignment });
    const triggerProps = {
        'aria-expanded': open,
        'aria-haspopup': 'dialog',
        'aria-controls': popoverLiteId,
        ref: triggerRef,
        className: 'popoverlite-trigger',
    };
    return (React.createElement(StyledPopoverLiteContainer, { ref: containerRef },
        React.createElement(StyledTriggerContainer, { open: open, withTip: withTip }, React.cloneElement(triggerElement, triggerProps)),
        React.createElement(StyledPopoverLite, { id: popoverLiteId, open: open, role: "dialog", ref: bubbleRef, "aria-hidden": !open }, content)));
};
//# sourceMappingURL=PopoverLite.mjs.mjs.map